export const formatDate = (date: string) => {
    var dateD = new Date(date);

    var dia = dateD.getDate().toString().padStart(2, '0');
    var mes  = (dateD.getMonth()+1).toString().padStart(2, '0');
    var ano  = dateD.getFullYear();

    var hora = (dateD.getHours()-3).toString().padStart(2, '0');
    var minutos = dateD.getMinutes().toString().padStart(2, '0');

    return `${dia}/${mes}/${ano} ${hora}:${minutos}`;
}

export const formatOnlyDate = (date: string) => {
    var dateD = new Date(date);

    var dia = dateD.getDate().toString().padStart(2, '0');
    var mes  = (dateD.getMonth()+1).toString().padStart(2, '0');
    var ano  = dateD.getFullYear();

    var hora = (dateD.getHours()-3).toString().padStart(2, '0');
    var minutos = dateD.getMinutes().toString().padStart(2, '0');

    return `${dia}/${mes}/${ano}`;
}